import { useAtomValue, useSetAtom } from 'jotai';
import { useState } from 'react';

import { participantCountAtom } from '../../video-sdk';
import { useToggleClientInformationDrawerCallback } from '../client-information';
import { hasNewFormsAtomFamily, inSessionClientHasPendingFormsAtom } from '../client-information/state';
import { useTrackClientInfoClicked } from '../client-information/useTrackClientInfoClicked';
import { PUSH_DRAWER_ARIA_CONTROLS_ID } from '../constants';
import { drawerStateAtom, inSessionPatientInformationAtom } from '../state';
import { getIsClientInfoDrawerOpen } from '../utils';
import { ClientInformationDrawerControlButton } from './ClientInformationDrawerControlButton';

export function ClientInformationDrawerControlButtonWrapper() {
  const toggleClientInformationDrawer = useToggleClientInformationDrawerCallback();
  const inSessionClientInformation = useAtomValue(inSessionPatientInformationAtom);

  const trackClientInfoClicked = useTrackClientInfoClicked(inSessionClientInformation?.patientShortId);
  const setDrawerState = useSetAtom(drawerStateAtom);
  const drawerState = useAtomValue(drawerStateAtom);
  const clientInfoDrawerIsOpen = getIsClientInfoDrawerOpen(drawerState);
  const isInSession = useAtomValue(participantCountAtom) > 0;
  const hasInSessionClientInformation = useAtomValue(inSessionClientHasPendingFormsAtom);
  const hasNewForms = useAtomValue(hasNewFormsAtomFamily(inSessionClientInformation?.patientShortId ?? ''));
  const [hasOpenedDrawer, setHasOpenedDrawer] = useState(false);
  const showVisualIndicator = !hasOpenedDrawer && (hasInSessionClientInformation || hasNewForms);

  if (!isInSession || !inSessionClientInformation?.visitorUuid) {
    return;
  }

  const onClientInformationButtonClick = () => {
    toggleClientInformationDrawer({
      visitorUuid: inSessionClientInformation.visitorUuid,
      patientShortId: inSessionClientInformation.patientShortId,
    });
    setHasOpenedDrawer(true);
    void trackClientInfoClicked('in_session_control_button');
  };

  return (
    <ClientInformationDrawerControlButton
      drawerId={PUSH_DRAWER_ARIA_CONTROLS_ID}
      drawerState={drawerState}
      showVisualIndicator={showVisualIndicator}
      onClientInformationButtonClick={
        clientInfoDrawerIsOpen ? () => setDrawerState(null) : () => onClientInformationButtonClick()
      }
    />
  );
}
